import {createAsyncAction} from 'typesafe-actions';
import {AxiosError} from 'axios';
import {ISetWebEditorJob} from 'lib/api/setWebEditorJob';

export const SAVE_POST = 'setWebEditorJob/SAVE_POST';
export const SAVE_POST_SUCCESS = 'setWebEditorJob/SAVE_POST_SUCCESS';
export const SAVE_POST_ERROR = 'setWebEditorJob/SAVE_POST_ERROR';

export const setWebEditorJobAction = createAsyncAction(
  SAVE_POST,
  SAVE_POST_SUCCESS,
  SAVE_POST_ERROR,
)<ISetWebEditorJob, ISetWebEditorJob, AxiosError>();
